module.exports = __webpack_public_path__ + "assets/img/team-button-create-67d4b42c.png";